module.exports = __webpack_public_path__ + "2ad1848e48071bbf0d463b3410fd1abe.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/help/help-center.png
// module id = 462
// module chunks = 0